import { PresetSchema } from "@redotech/redo-fulfillment-parcel-common/presets";
import * as z from "zod";

export const createPreset = {
  name: "createPreset" as const,
  input: z.object({ preset: PresetSchema.omit({ _id: true }) }),
  output: z.object({ success: z.boolean() }),
};
